<template>
  <div id="main-select">

    <div id="grid-table-contents">
      <div class="grid-table-scroll">
        <table class="table table-sm table-striped sticky_table">
          <thead>
            <tr>
              <th class="col-check">チェック</th>
              <th class="col-order-id">注文番号</th>
              <th class="col-header-item">商品名</th>
              <th class="col-name">名前</th>
              <th class="col-postal-code">郵便番号</th>
              <th>住所</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in getShippingData"
              v-bind:key="index"
              v-bind:id = "row.index"
              >
              <td @click="onClickMark(row)">
                <CheckedMark
                  :checked="row.checked"
                  :failureMark="false"
                />
              </td>
              <td>{{row.orderId}}</td>
              <td>
                <div v-for="(item, itemNum) in row.items" v-bind:key="itemNum" class="col-item">
                  {{item.productName}}
                </div>
              </td>
              <td>{{row.recipientName}}</td>
              <td>{{row.shipPostalCode}}</td>
              <td class="col-address">{{row.shipState + ' ' + row.shipCity + ' ' + row.shipAddress1 + ' ' + row.shipAddress2 + ' ' + row.shipAddress3}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import createStore from '@/store/index.js'
import CheckedMark from '@/components/CheckedMark.vue'

export default defineComponent({
  components: {
    CheckedMark
  },
  setup () {
    const store = createStore

    const getShippingData = computed(() => {
      return store.getters.getShippingData
    })

    const onClickMark = (row) => {
      // 選択したデータのチェック
      store.commit('updateShippingRecord', { row: row })
    }

    return {
      onClickMark,
      getShippingData
    }
  }
})
</script>

<style lang="scss" scoped>
#main-select {
  #grid-table-contents {
    position: absolute;
    height: 100%;
    width: 100%;
    font-size: small;

    .grid-table-scroll {
      position: relative;
      overflow-y: scroll;
      height: 100%;
      width: 100%;

      .sticky_table {
        width: 100%;
        white-space: nowrap;
        vertical-align: middle;

        thead th {
          /* 縦スクロール時に固定する */
          position: sticky;
          top: 0;
          /* tbody内のセルより手前に表示する */
          z-index: 1;
          background: #604878;
          color: white;
          text-align: center;
        }
        tr {
          height: 1rem;
          padding-top: 0;
          padding-bottom: 0;
          margin-top: 0;
          margin-bottom: 0;
        }
        td {
          background: white;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 0;
          border-right: black 0.5px solid;
        }
        .col-check {
          width: 2rem;
        }
        .col-header-number {
          width: 3rem;
        }
        .col-order-id {
          width: 14rem;
        }
        .col-postal-code {
          width: 8rem;
        }
        .col-item {
          text-align: left;
          white-space: nowrap;
        }
        td.col-address {
          text-align: left;
          white-space: nowrap;
        }
        td.col-send {
          width: 5rem;
        }
        td.col-shelf-number {
          white-space: nowrap;
        }
        .col-name {
          width: 6rem;
        }
      }
    }
  }
}
</style>
